<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">판매등록</span>
            <span class="txt">판매 상품을 결제 등록, 수정, 삭제 할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['결제수단', '카드', '현금', '계좌이체', '마일리지', '기타']"
                    :select-value="['', 'C', 'L', 'B', 'M', 'E']"
                    :selected-value="payType"
                    class="w220"
                    @update:set="(val) => (payType = val)"
                ></select-form>
                <select-form
                    :select-data="['판매자', ...saleStaffList]"
                    :select-value="['', ...saleStaffValList]"
                    :selected-value="saleStaff"
                    class="w220"
                    @update:set="(val) => (saleStaff = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/sales/sell/edit">판매 등록</router-link>
                    <router-link class="com-btn blue" to="/madmin/sales/setting">설정</router-link>
                    <!-- <a href="#" class="com-btn blue">판매 등록</a>
                    <a href="#" class="com-btn blue">설정</a> -->
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 130px" />
                    <col style="width: 125px" />
                    <col style="width: 290px" />
                    <col style="width: 90px" />
                    <col style="width: 170px" />
                    <col style="width: 170px" />
                    <col style="width: 125px" />
                    <col style="width: 145px" />
                    <col style="width: 190px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>결제일</button>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button>상품명</button>
                        </th>
                        <th>
                            <button>구매수량</button>
                        </th>
                        <th>
                            <button>결제정보</button>
                        </th>
                        <th>
                            <button>마일리지</button>
                        </th>
                        <th>
                            <button>판매자</button>
                        </th>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>
                    <td>2019-12-25</td>
                    <td>홍길동</td>
                    <td>요가복 상의</td>
                    <td>1</td>
                    <td>카드 20,000원</td>
                    <td>200원 적립</td>
                    <td>김윤경</td>
                    <td>2020-01-01 16:45</td>
                    <td>
                        <button class="com-btn blue">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr> -->
                    <tr v-for="i in itemList" :key="i.ccp_center_contract_id">
                        <td>{{ i.ccp_buy_dt | timestampFilter }}</td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${i.ccp_center_id}`,
                                    query: { customerId: i.ccp_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ i.ccp_customer_name }}
                            </router-link>
                        </td>
                        <td>{{ i.ccp_prod_nm }}</td>
                        <td>{{ i.ccp_total_prod_cnt }}</td>
                        <td>
                            {{ convertProdCd(i.ccp_pay_type_cd) }} {{ i.ccp_prod_buy_price | numberFormatFilter }}원
                        </td>
                        <!-- <td>{{convert(i.cc_bill_info) | numberFormatFilter}}원</td> -->
                        <td>{{ i.ccp_mileage ? i.ccp_mileage : '0' | numberFormatFilter }}원 적립</td>
                        <td>{{ i.ccp_center_staff_name ? i.ccp_center_staff_name : '-' }}</td>
                        <td>{{ i.ccp_cre_dt | timestampFilter3 }}</td>
                        <td>
                            <router-link
                                :to="{
                                    name: `SalesSellModify`,
                                    query: {
                                        contractId: i.ccp_center_contract_id,
                                        productId: i.ccp_center_prod_id,
                                        name: i.ccp_customer_name,
                                    },
                                }"
                                class="com-btn blue"
                            >
                                수정
                            </router-link>
                            <!-- <button class="com-btn blue">수정</button> -->
                            <button class="com-btn red" @click="onDeleteItem(i.ccp_center_contract_id)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="itemList == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    class="float-right"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import XLSX from 'xlsx';
import { dateFormatFilter, timestampToDate } from '@/assets/js/excelCommon.js';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SalesSell',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchList();
        },
        startDate(newValue) {
            this.startDate = newValue;
        },
        endDate(newValue) {
            this.endDate = newValue;
        },
        payType(newValue) {
            this.payType = newValue;
            this.onSearchList();
        },
        saleStaff(newValue) {
            this.saleStaff = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            pagingInfo: { ...pagingInfo },
            centerId: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'thisMonth',
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],

            itemList: [], // 아이템 목록 리스트
            centerProductId: '', // 센터 상품 아이디

            searchStr: '',
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            payType: '',

            saleStaff: '',
            saleStaffList: [],
            saleStaffValList: [],

            count: 1,
        };
    },
    mounted() {
        this.goMainIfNotAllowed('SA', 3);
        this.centerId = this.cId; // 센터id
        this.init();
    },
    methods: {
        // 초기화
        init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            Promise.allSettled([this.onSearchList(), this.onStaffList()]);
        },

        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.getItemListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((i) => {
                const temp = {};
                temp['결제일'] = timestampToDate(i.ccp_cre_dt);
                temp['회원명'] = i.ccp_customer_name;
                temp['상품명'] = i.ccp_prod_nm;
                temp['구매수량'] = i.ccp_total_prod_cnt;
                temp['결제정보'] = this.convert(i.cc_bill_info);
                temp['마일리지'] = i.ccp_ret_mileage_price;
                temp['판매자'] = i.ccp_center_staff_name;
                temp['등록일'] = dateFormatFilter(i.ccp_cre_dt);

                excelDownloadArray.push(temp);
            });
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '판매등록');
            XLSX.writeFile(wb, '판매등록.xlsx');
        },
        // 엑셀다운로드를 위한 리스트
        getItemListExcel() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/contract`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    searchStr: this.searchStr,
                    payType: this.payType,
                    centerStaffId: this.saleStaff, // 판매자 아이디
                    page: 1,
                    limit: 10000,
                },
            });
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            this.searchStr = '';
            this.payType = '';
            this.saleStaff = ''; // 판매자 아이디
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },
        // 리스트
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getItemList();
                this.itemList = data.items;
                this.setPageParams(data);
                console.log('아이템 리스트 : ', data);
            } catch (error) {
                console.log(error);
                alert('에러입니다.');
            }
        },
        // 리스트 호출 api
        getItemList() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/contract`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    searchStr: this.searchStr,
                    payType: this.payType,
                    centerStaffId: this.saleStaff, // 판매자 아이디
                    ...this.pagingInfo,
                },
            });
        },
        // 리스트 삭제
        async onDeleteItem(index) {
            try {
                confirm('삭제하시겠습니까?');
                console.log(index);
                this.centerProductId = index;
                const { data } = await this.deleteItem();
                console.log('삭제되었습니다.');
                this.onSearchList(); // 리스트 함수 호출
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 판매상품삭제 api
        deleteItem() {
            return api.delete(`/admin/api/center/${this.centerId}/uniform/contract/${this.centerProductId}`);
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
        // 검색 조건 초기화
        resetSearchParams() {
            this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        convertProdCd(type) {
            if (type == 'C') {
                return '카드';
            } else if (type == 'L') {
                return '현금';
            } else if (type == 'M') {
                return '마일리지';
            } else if (type == 'B') {
                return '계좌이체';
            } else if (type == 'E') {
                return '기타';
            }
        },
        // 직원목록 가져오기
        async onStaffList() {
            try {
                const { data } = await this.getStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('직원목록', data);
                data.forEach((g) => {
                    this.saleStaffList.push(g.name);
                    this.saleStaffValList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        convert(val) {
            // 결제정보
            const result = val.split('_');
            let code = '';
            switch (result[0]) {
                case 'C':
                    code = '카드';
                    break;
                case 'L':
                    code = '현금';
                    break;
                case 'B':
                    code = '계좌';
                    break;
                case 'M':
                    code = '마일리지';
                    break;
                case 'E':
                    code = '기타';
                    break;
            }
            return `${code} ${result[1]}`;
        },
    },
};
</script>
<style lang="scss"></style>
